import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/api/auth.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'user-menu-navigation',
  templateUrl: './user-menu-navigation.component.html',
  styleUrls: ['./user-menu-navigation.component.scss']
})
export class UserMenuNavigationComponent implements OnInit {
  @Input() currency: string;
  @Input() isSmallMenu = true;

  languageLink = '';
  isLoggedIn = false;

  constructor(private localeService: LocaleService, private authService: AuthService) {}

  ngOnInit() {
    const isArabic = this.localeService.isArabic();
    this.updateLink(isArabic);
    this.isLoggedIn = !!this.authService.getToken();
  }

  updateLink(isArabic: boolean) {
    const from = isArabic ? '/ar/' : '/en/';
    const to = isArabic ? '/en/' : '/ar/';
    this.languageLink = window.location.href.replace(from, to);
  }
}
